import React from 'react';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { drapcodeIcon } from '../../common/custom/icon-library';
import showAlert from '../../common/utils/alert';

const SettingTable = ({ setting, projectId, version, page, actions, history, projectDetail }) => {
  const showDatabaseConfig = (config) => {
    if (!config) {
      return '-';
    }
    const { host, port, username } = config;
    return (
      <>
        {host && (
          <>
            <span className="font-weight-normal">Host: </span>
            <span className="font-weight-light">{host}</span>
          </>
        )}
        {port && (
          <>
            , <span className="font-weight-normal">Port: </span>
            <span className="font-weight-light">{port}</span>
          </>
        )}
        {username && (
          <>
            , <span className="font-weight-normal">Username: </span>
            <span className="font-weight-light">{username}</span>
          </>
        )}
      </>
    );
  };

  const handleDelete = () => {
    const preConfirm = () => {
      actions.deleteDeploymentSetting({ projectId, uuid: setting.uuid }).then((res) => {
        history.push(`/deployment-setting/${version}/v/${projectId}`);
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  const publishDeploymentSetting = () => {
    let { seoName, name } = projectDetail;
    name = `${name}-${moment().format('YYYY-MM-DD-HH-mm-ss')}`;
    const obj = {
      projectId: projectId,
      version,
      uuid: setting.uuid,
      seoName,
      name,
    };
    const preConfirm = () => actions.publishDeploymentSetting(obj);
    showAlert('Use this setting to create your build.', preConfirm, 'Yes, use it!');
  };

  return (
    <tr>
      <td>{setting.name}</td>
      <td>
        {setting.domainName && (
          <a href={`https://${setting.domainName}`}>https://{setting.domainName}</a>
        )}
      </td>
      <td>
        {setting.apiDomainName && (
          <a href={`https://${setting.apiDomainName}`}>https://{setting.apiDomainName}</a>
        )}
      </td>
      <td>{showDatabaseConfig(setting.configDB)}</td>
      <td>{showDatabaseConfig(setting.itemDB)}</td>
      <td>
        {/* <Link
          className="btn btn-theme-submit btn-xs"
          to={`/deployment-setting/${version}/v/${projectId}/update/${setting.uuid}`}
          title={`Edit ${setting.name}`}
        >
          <i className={`wb ${drapcodeIcon('edit')}`} size={'md'}></i>
        </Link> */}
        &nbsp;
        <button
          type="button"
          className="btn btn-primary btn-xs"
          title={`Export ${setting.name}`}
          onClick={publishDeploymentSetting}
        >
          <i className={`wb ${drapcodeIcon('publish-activity')}`} size={'md'}></i>
        </button>
        &nbsp;
        <button
          type="button"
          className="btn btn-xs btn-theme-delete"
          title={`Delete ${setting.name}`}
          onClick={handleDelete}
        >
          <i className={`wb ${drapcodeIcon('delete')}`} size={'md'}></i>
        </button>
      </td>
    </tr>
  );
};

export default SettingTable;
